import makeStyles from '@mui/styles/makeStyles';

export const serviceStyles = makeStyles(theme => ({
  paper: {
    padding: 8
  }
}));
